/**
 * QL-f — wording for the identity conflict panel. The panel is shown on the
 * advisor page and the public client page, so the question is phrased once.
 *
 * Deliberately neutral: a mismatch is usually a married name, a typo or a
 * document that predates a change, not fraud. Wording that accused the reader
 * of the last one would be wrong nearly every time it appeared.
 */

export const T = {
  en_GB: {
    title: "The document does not match our records",
    description:
      "Check each difference below. Update our records from the document, or keep what we have.",
    ours: "Our records",
    theirs: "The document",
    update: "Use the document",
    ignore: "Keep ours",
    answered: "Answered",
    blocking: "Answer every difference to continue.",
    failed: "That did not save — please try again.",
    fieldName: "Name",
    fieldDob: "Date of birth",
    fieldCountry: "Country",
  },
  nb_NO: {
    title: "Dokumentet stemmer ikke med det vi har registrert",
    description:
      "Se gjennom hver forskjell under. Oppdater det vi har registrert fra dokumentet, eller behold vårt.",
    ours: "Registrert hos oss",
    theirs: "Dokumentet",
    update: "Bruk dokumentet",
    ignore: "Behold vårt",
    answered: "Besvart",
    blocking: "Svar på alle forskjellene for å gå videre.",
    failed: "Dette ble ikke lagret — prøv igjen.",
    fieldName: "Navn",
    fieldDob: "Fødselsdato",
    fieldCountry: "Land",
  },
} as const;
